import { render, staticRenderFns } from "./PortIntelligentDistribution.vue?vue&type=template&id=61fb0f9a&"
import script from "./PortIntelligentDistribution.vue?vue&type=script&lang=js&"
export * from "./PortIntelligentDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports